window.PromocodeNotifier = {
	showNotify(data) {
		new fbx.Fancybox([
			{
				src: `
					<div class="promocode-notifier">
						${data.title ? `<h2>${data.title}</h2>` : ''}
						${data.text ? `<div class="page-default mt-3">${data.text}</div>` : ''}
					</div>
				`,
				type: "html",
			},
		]);

		this.setViewed(data.id);
	},

	setViewed(id) {
		$.post('/promocodes/set_notify_viewed', {id: id, _token: App.csrf});
	}
};

$(document).ready(function () {
	if (App.promocodes.length) {
		setTimeout(() => {
			PromocodeNotifier.showNotify(App.promocodes[0]);
		}, 1000 * 40);
	}
});
